import React from "react";
import Introduction from "./utils/Introduction";
import Mission3 from "./utils/Mission3";
import Mission2 from "./utils/Mission2";
import End from "./utils/End";

export function OpenDataPortal(props) {
  return (
    <div className="challenge-details container">
      <div>
        <Introduction
          logo={props.logo}
          track="Artificial Intelligence Engineer"
        />
        <h2 className="mission-1">
          Mission 1: Create a <strong>AI Model</strong>
        </h2>
        <h3>Description</h3>
        <p>
          Download the “Monatszahlen Verkehrsunfälle” Dataset from the{" "}
          <a
            href="https://www.opengov-muenchen.de/dataset/monatszahlen-verkehrsunfaelle/resource/40094bd6-f82d-4979-949b-26c8dc00b9a7"
            target="_blank"
          >
            München Open Data Portal.{" "}
          </a>
          Here you see the number of accidents for specific categories per
          month. Important are the first 5 columns:
          <ul>
            <li> Category</li>
            <li>Accident-type (insgesamt means total for all subcategories)</li>
            <li> Year</li>
            <li> Month</li>
            <li> Value</li>
          </ul>
        </p>

        Your goal would be to visualise historically the number of accidents
        per category (column1). The dataset currently contains values until the end of 2020. Create
        an application that forecasts the values for: <br /> <br />
        <ul>
        <li> Category: 'Alkoholunfälle'</li>
        <li> Type: 'insgesamt</li>
        <li> Year: '2021'</li>
        <li> Month: '01'</li>
        </ul>

        <p>Note: There has been recently some update on the data shared with you for the AI Engineering Challenge. The dataset has recently been updated and includes values until 2021. You should drop the records which come after 2020 for developing the prediction model. If you are interested, you can compute the error between your prediction values and the actual numbers (ground truth data).</p>
        <Mission2 track="AI Engineer" />
        <Mission3 notes="you can  write some notes to us. These notes can be anything you would like us to know, especially for technical decisions. They are not mandatory, so you can also skip this this parameter." />
        <End />
      </div>
    </div>
  );
}
